import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { AnimatePresence, motion } from 'framer-motion';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';


const HeroContainer = styled.div<{ isMobile: boolean }>`
  position: relative;
  width: 100%;
  aspect-ratio: ${({ isMobile }) => (isMobile ? '4 / 5' : '2.4 / 1')};
  overflow: hidden;
`;

const SlideImage = styled(motion.img)`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`;

const slideVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

interface HeroBannerProps {
  slides: {
    id: number,
    image: any,
    url: string;
  }[];
  isMobile: boolean;
}

export const HeroBanner = ({
  slides,
  isMobile,
}: HeroBannerProps) => {
  
  const navigate = useNavigate();
  const [current, setCurrent] = useState(0);
  // Change slide every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <HeroContainer isMobile={isMobile}>
      <AnimatePresence>
        <SlideImage
          key={slides[current].id}
          src={slides[current].image}
          alt={`Slide ${slides[current].id}`}
          variants={slideVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 1 }}
          onClick={() => {
            if (slides[current].url) {
              navigate(slides[current].url)
            }
          }}
        />
      </AnimatePresence>
    </HeroContainer>
  );
};

export default HeroBanner;